'use client';
import React from 'react';
import { PuffLoader } from 'react-spinners';
import { GalleryPageProps } from '@/app/_blocks/GalleryPageGraphQL/types';
// import { DebugJsonBlock } from '../DebugJsonBlock';
import { Gutter } from '../Gutter';
import { GalleryPageProvider, useGalleryPageState } from './GalleryPageContext';
import { GalleryPageFilters } from './GalleryPageFilters';
import { VideoGrid } from './VideoGrid';
import { GalleryImageGrid } from './GalleryImageGrid';
import { VideoItem, GalleryImageItem } from '@/app/_api/fetchGalleryContent';

import classes from './GalleryPage.module.scss';

const GalleryPageContent: React.FC<{
  className?: string;
  galleryPage: GalleryPageProps;
}> = ({ className, galleryPage }) => {
  const { data } = useGalleryPageState();
  const { galleryContent, contentLoading, loading, error } = data;

  return (
    <Gutter>
      <div className={[className, classes.wrapper].filter(Boolean).join(' ')}>

        <GalleryPageFilters />

        {contentLoading && (
          <div role="status" aria-label="Loading" style={{ display: 'flex', justifyContent: 'center' }}>
            <PuffLoader color='#fff' size={32} aria-hidden="true" />
          </div>
        )}

        {!loading && !error && !contentLoading && (
          <div style={{ marginBottom: '2rem' }}>
            {galleryPage.galleryType === 'Video' ? (
              <VideoGrid videos={galleryContent as VideoItem[]} />
            ) : (
              <GalleryImageGrid images={galleryContent as GalleryImageItem[]} />
            )}
          </div>
        )}
      </div>
    </Gutter>
  );
};

export const GalleryPage: React.FC<{
  className?: string;
  galleryPage: GalleryPageProps;
}> = ({ className, galleryPage }) => {
  return (
    <GalleryPageProvider
      galleryType={galleryPage.galleryType}
      useCaseTaxonomies={galleryPage.useCaseTaxonomies}
      productTaxonomies={galleryPage.productTaxonomies}
      hideFilterBar={galleryPage.hideFilterBar}
      hideSearchBar={galleryPage.hideSearchBar}>
      <GalleryPageContent className={className} galleryPage={galleryPage} />
    </GalleryPageProvider>
  );
};

export default GalleryPage;
